import { Summary } from '@/modules/report/slice/betSummary';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GetGameName, GetGameShoeRound } from '../../util';
import './RecordGameRoundText.scss';

type RecordGameRoundTextProps = {
    summary: Summary;
    withSlash?: boolean;
};
export const RecordGameRoundText = (props: RecordGameRoundTextProps) => {
    const { t } = useTranslation();

    const { GameType, Round, Shoes, HostID } = props.summary;
    const { withSlash = false } = props;

    const { i18n } = useTranslation();
    const languageDir = useMemo(() => {
        return i18n.dir(i18n.language);
    }, [i18n.language]);

    const gameName = useMemo(
        () => GetGameName(GameType, HostID, t),
        [GameType, HostID, i18n.language]
    );

    const shoeRound = useMemo(
        () => GetGameShoeRound(GameType, Round, Shoes),
        [GameType]
    );

    return (
        <div
            className={`record-show-round-text-wrapper ${withSlash ? 'slash' : ''}`}
        >
            {!withSlash || languageDir !== 'rtl' ? (
                <>
                    <span>{`${gameName} ${withSlash ? '/' : ''}\u00A0`}</span>
                    <span>{shoeRound}</span>
                </>
            ) : (
                <>
                    <span>{shoeRound}</span>
                    <span>{`\u00A0${withSlash ? '/' : ''} ${gameName}`}</span>
                </>
            )}
        </div>
    );
};
